import { BaseComponent } from "../BaseComponent";

import { Guid } from "../../Utils/Guid";

import { SelectEditorFactory } from "../Factories/SelectEditorFactory";

import * as React from "react";
import { Content } from "../Resources/Content";

export interface IResultsPerPageProps extends React.Props<ResultsPerPage> {
    onChange: (recordsPerPage: number) => void;
    selectedValue: number;
    recordsPerPageOptions: number[];
}

export interface IResultsPerPageState {}

export class ResultsPerPage extends BaseComponent<IResultsPerPageProps, IResultsPerPageState> {
    private _selectId = Guid.getNext();

    constructor(props: IResultsPerPageProps) {
        super(props);
        this.state = {};
    }

    public render(): JSX.Element {
        const PagesDropdown = SelectEditorFactory.create<number>();

        return (
            <div className="row row-right narrow-gutter text-right">
                <div className="col-sm-auto col-middle">
                    <label className="block mt-12 mb-12" htmlFor={this._selectId}>
                        {Content.Records_per_page_label}
                    </label>
                </div>
                <div className="col-auto">
                    <PagesDropdown
                        id={this._selectId}
                        cssWrapper="mb-0"
                        onChange={(value) => this.props.onChange(value)}
                        selected={this.props.selectedValue}
                        getText={(value: number) => value.toString()}
                        options={this.props.recordsPerPageOptions}
                    />
                </div>
            </div>
        );
    }
}
